import { defineComponent as _defineComponent } from 'vue'

export {
  OzContainedButtonColorScheme as OzIconButtonColorScheme,
  OzContainedButtonHrefMode as OzIconButtonHrefMode,
  OzContainedButtonSizePreset as OzIconButtonSizePreset,
} from '@@/library/v4/components/OzContainedButton.vue'

const __default__ = {}

import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonHrefMode,
  OzContainedButtonSizePreset,
} from '@@/library/v4/components/OzContainedButton.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzIconButton',
  props: {
    label: null,
    iconName: null,
    iconFont: { default: 'oricon' },
    iconSize: { default: undefined },
    sizePreset: { default: OzContainedButtonSizePreset.H40px },
    colorScheme: { default: OzContainedButtonColorScheme.Primary },
    darkMode: { type: [Boolean, String], default: 'auto' },
    activeIconName: { default: undefined },
    disabled: { type: Boolean, default: false },
    href: { default: undefined },
    hrefMode: { default: OzContainedButtonHrefMode.Default }
  },
  setup(__props: any) {

const props = __props as { label: string, iconName: string, iconFont: 'immaterial' | 'oricon', iconSize: number, sizePreset: OzContainedButtonSizePreset, colorScheme: OzContainedButtonColorScheme, darkMode: boolean | 'auto', activeIconName: string, disabled: boolean, href: string, hrefMode: OzContainedButtonHrefMode }

/**
 * @file Icon-only button. A shortcut for using OzContainedButton with only an icon.
 * Allows using a different icon for active state and automatically paints it
 * using selection color.
 */


const isActive = computed((): boolean => {
  return props.colorScheme
    ? [OzContainedButtonColorScheme.SecondaryActive, OzContainedButtonColorScheme.SecondaryClearActive].includes(
        props.colorScheme,
      )
    : false
})

const presetIconSize = computed((): number => {
  switch (props.sizePreset) {
    case OzContainedButtonSizePreset.H40px:
      return 16
    case OzContainedButtonSizePreset.H32px:
      return 20
    case OzContainedButtonSizePreset.H24px:
      return 16
    default:
      return 24
  }
})

return { __sfc: true,props, isActive, presetIconSize, OzContainedButton, OzIcon }
}

})